import { useState } from "react";
import styles from "../../../styles/Blog/MobilePopular.module.css";
import PopularPost from "../PopularPost";

const MobilePopular = ({blogs}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleLeftClick = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + blogs.length) % blogs.length
    );
  };

  const handleRightClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % blogs.length);
  };

  return (
    <div className={styles.MobilePopularContainer}>
      <div className={styles.MobilePopularInnerContainer}>
        <div className={styles.MobilePopularTitle}>Popular Posted</div>
        <div className={styles.MobilePopularArrowContainer}>
          <span>
            <img onClick={handleRightClick} src="/red_arrow_circle_left.svg" alt="left_arrow" loading="lazy" />
          </span>
          <span>
            <img onClick={handleLeftClick} src="/red_arrow_circle_right.svg" alt="right_arrow" loading="lazy" />
          </span>
        </div>
      </div>
      {blogs.length > 0 && blogs[currentIndex] && (
        <div className={styles.MobilePopularPopularPostContainer}>
          <PopularPost data={blogs[currentIndex]} />
        </div>
      )}
    </div>
  );
};

export default MobilePopular;
